import React from "react";
import { Card, Col, Form, Row } from "react-bootstrap";
import "./check-filter.scss";

const CheckFilter = ({
  brandIdData,
  categoryIdData,
  handleFiltersChange,
  filters,
}) => {
  return (
    <section className="check-filter">
      <Row>
        <Col xs={6} sm={4} md={12}>
          <div className="categories-filter mb-4">
            <Card>
              <Card.Title>Categories</Card.Title>
              <Form>
                {categoryIdData.map((category) => (
                  <Form.Group className="mb-1" key={category.id}>
                    <Form.Check
                      type="checkbox"
                      name="categories"
                      label={category.title}
                      value={category.id}
                      checked={filters.categories.includes(
                        category.id.toString()
                      )}
                      onChange={handleFiltersChange}
                    />
                  </Form.Group>
                ))}
              </Form>
            </Card>
          </div>
        </Col>
        <Col xs={6} sm={4} md={12}>
          <div className="brands-filter mb-4">
            <Card>
              <Card.Title>Brands</Card.Title>
              <Form>
                {brandIdData.map((brand) => (
                  <Form.Group className="mb-1" key={brand.id}>
                    <Form.Check
                      type="checkbox"
                      name="brands"
                      label={brand.name}
                      value={brand.id}
                      checked={filters.brands.includes(brand.id.toString())}
                      onChange={handleFiltersChange}
                    />
                  </Form.Group>
                ))}
              </Form>
            </Card>
          </div>
        </Col>
        <Col xs={12} sm={4} md={12}>
          <div className="price-filter mb-4">
            <Card>
              <Card.Title>Price</Card.Title>
              <Form>
                <Form.Group>
                  <Form.Label>Min</Form.Label>
                  <Form.Control
                    type="number"
                    name="minPrice"
                    value={filters.minPrice}
                    onChange={handleFiltersChange}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>Max</Form.Label>
                  <Form.Control
                    type="number"
                    name="maxPrice"
                    value={filters.maxPrice}
                    onChange={handleFiltersChange}
                  />
                </Form.Group>
              </Form>
            </Card>
          </div>
        </Col>
      </Row>
    </section>
  );
};

export default CheckFilter;
